import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../../Command";
import { FetchDashboardResData } from "./FetchDashboardResData";

const ENDPOINT = "/dashboard/";

export class FetchDashboardCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    breakpoint: string;

    constructor(dashboardId: number, breakpoint: string) {
        super();
        this.endPoint += dashboardId;
        this.breakpoint = breakpoint;
    }

    public async execute(): Promise<FetchDashboardResData> {
        var res = await this.executeCommand();
        return new FetchDashboardResData(res, this.breakpoint);
    }
}
